import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "@pages/Home";
import Packages from "@pages/Packages";
import Contact from "@pages/Contact";
import PackageInfo from "@pages/PackageInfo";
import Services from "@pages/Services";
import ServiceDetail from "@pages/ServiceDetail";
import Checkout from "@pages/Checkout";
import About from "@pages/About";
import NotFound from "@pages/NotFound";
import Blogs from "@pages/Blogs";
import BlogArticle from "@components/BlogArticle";
import MainLayoutWrapper from "@layouts/MainLayoutWrapper";
import { CartProvider } from "@providers/CartProvider";
import { FormProvider } from "@providers/FormProvider";
import { StripeProvider } from "@providers/StripeProvider";
import "./index.css";

createRoot(document.getElementById("root")).render(
	<StrictMode>
		<HelmetProvider>
			<StripeProvider>
				<CartProvider>
					<FormProvider>
						<Router>
							<Routes>
								<Route element={<MainLayoutWrapper />}>
									<Route path="/" element={<Home />} />
									<Route path="/packages" element={<Packages />} />
									<Route path="/contact" element={<Contact />} />
									<Route path="/services" element={<Services />} />
									<Route
										path="/services/:serviceId"
										element={<ServiceDetail />}
									/>
									<Route path="/checkout" element={<Checkout />} />
									<Route path="/about" element={<About />} />
									<Route
										path="/packageinfo/:packagename"
										element={<PackageInfo />}
									/>
									<Route path="/articles" element={<Blogs />} />
									<Route path="/articles/:slug" element={<BlogArticle />} />
									<Route path="*" element={<NotFound />} />
								</Route>
							</Routes>
						</Router>
					</FormProvider>
				</CartProvider>
			</StripeProvider>
		</HelmetProvider>
	</StrictMode>
);
